export const vaultExceptions = {
  fetchFolderById: "Error al obtener el expediente",
  updateVaultFormValues: "Error al actualizar el formulario del expediente",
  uploadFileToVault: "Error al subir el archivo al expediente",
  fetchVaultRequirementById: "Error al obtener requisito del expediente",
  onCancelRequirementVaultToReview:
    "Error al cancelar el envío a revisión del expediente",
  generateJWT: "El correo capturado no está asociado a este expediente",
};
